import { set, reduce, get } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { fetchPosTrackingMethods } from '../../../sagas/pos/routines';
import { Status as TrackingMethodStatus } from '../../../../../constants/tracking-method';

const initialState = {
  all: [],
  fetching: false,
  fetched: false
};

const fetchHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(
      'all',
      reduce(
        (items, { value: id, label, meta }) =>
          get('status', meta) === TrackingMethodStatus.ACTIVE
            ? [...items, { id, label }]
            : items,
        [],
        response.items
      ),
      state
    ),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchHandler(fetchPosTrackingMethods)
});
